// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopMiniBasketModel from '../../model/shop-mini-basket-model';
import ShopMiniBasketDTO from '../dto/shop-mini-basket-dto';
import dtoSchema from '../schemas/shop-mini-basket-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class ShopMiniBasketModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopMiniBasketDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.publicBasketId = data.publicBasketId;
      this.itemsTotalQuantity = data.itemsTotalQuantity;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {uuid}
  */
  publicBasketId?: string;
  /**
  * @type {int32}
  */
  itemsTotalQuantity?: number;

  static toModel(dto: DeepPartial<ShopMiniBasketDTO>): ShopMiniBasketModel;
  static toModel(dto: DeepPartial<ShopMiniBasketDTO> | undefined | null): ShopMiniBasketModel | undefined;
  static toModel(dto: DeepPartial<ShopMiniBasketDTO> | undefined | null): ShopMiniBasketModel | undefined {
    return dto ? new ShopMiniBasketModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopMiniBasketModel> | ShopMiniBasketModel): ShopMiniBasketDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      publicBasketId: unwrapped.publicBasketId,
      itemsTotalQuantity: unwrapped.itemsTotalQuantity,
    } as ShopMiniBasketDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopMiniBasketModel, can not map to ShopMiniBasketDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
